import { Alert, CircularProgress, Snackbar } from "@mui/material";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "../../components/BaseUrl";
import SidebarComponent from "../../components/dashboard/Sidebar";
import Loader from "../../components/Loader";
import { AuthContext } from "../../context/authContext";

const NewInvestment = () => {
  const { admin, token } = useContext(AuthContext);
  const [form, setForm] = useState({
    user: "",
    pool: "",
    amount: "",
  });
  const [pools, setPools] = useState([]);
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  async function getInvestments() {
    try {
      axios
        .get(`${BASE_URL}/txns/pools`)
        .then((res) => {
          setPools(res.data.data);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.log(error);
    }
  }

  async function getUsers() {
    try {
      const { data } = await axios.get(`${BASE_URL}/txns/users`);
      setUsers(data.data);
    } catch (error) {
      console.log(error);
    }
  }

  async function investUser() {
    try {
      setIsLoading(true);
      const payload = {
        amount: Number(form.amount),
        poolId: form.pool,
        userDetails: form.user,
      };
      const { data } = await axios.post(`${BASE_URL}/pool/invest`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (data) {
        alert("User investment created successfully!");
        navigate("/investment");
      }
    } catch (error) {
      setError(error.response.data.message);
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    getInvestments();
    getUsers();
  }, []);

  return (
    <div>
      <div>
        <Loader />
      </div>
      <div>
        <SidebarComponent user={admin} />
      </div>
      <div className="p-4 sm:ml-64 bg-[#0a0c0f]">
        <div className="p-4 border border-gray-600 border-dashed rounded-lg dark:border-gray-700 mt-20 min-h-screen">
          <div>
            <h1 className="text-gray-400 text-xl font-medium mb-7">
              New Investment
            </h1>
          </div>
          <div className="grid md:grid-cols-3 gap-5">
            <div>
              <label htmlFor="user" className="text-gray-300 text-sm">
                User
              </label>
              <select
                name="user"
                className="bg-[#181b20] w-full py-3 px-5 text-gray-400 mt-2 outline-none rounded-md"
                onChange={(e) => {
                  const selectedUser = users?.find(
                    (u) => u._id === e.target.value
                  );
                  setForm({ ...form, user: selectedUser });
                }}
              >
                {users?.map((user) => {
                  return (
                    <option key={user._id} value={user._id}>
                      {user.name}
                    </option>
                  );
                })}
              </select>
            </div>
            <div>
              <label htmlFor="strategy" className="text-gray-300 text-sm">
                Strategy
              </label>
              <select
                name="strategy"
                className="bg-[#181b20] w-full py-3 px-5 text-gray-400 mt-2 outline-none rounded-md"
                onChange={(e) => {
                  setForm({ ...form, pool: e.target.value });
                }}
              >
                {pools?.map((i) => {
                  return (
                    <option key={i._id} value={i._id}>
                      {i.name}
                    </option>
                  );
                })}
              </select>
            </div>
            <div>
              <label htmlFor="amount" className="text-gray-300 text-sm">
                Amount
              </label>
              <input
                onChange={(e) => {
                  setForm({ ...form, amount: e.target.value });
                }}
                name="amount"
                value={form.amount}
                className="bg-[#181b20] w-full py-3 px-5 text-gray-400 mt-2 outline-none rounded-md"
              />
            </div>
            <button
              disabled={!form.user || !Number(form.amount) || !form.pool}
              onClick={() => {
                investUser();
              }}
              className="md:w-[150px] mt-4 w-full bg-[#b2ffce] px-5 py-2 rounded-md font-medium"
            >
              {isLoading ? (
                <CircularProgress color="inherit" size="25px" />
              ) : (
                "Submit"
              )}
            </button>
          </div>
        </div>
      </div>
      {error ? (
        <Snackbar open={true} autoHideDuration={5000}>
          <Alert severity="error">{error.replace("You are", "User is")}</Alert>
        </Snackbar>
      ) : null}
    </div>
  );
};

export default NewInvestment;
